import { render, staticRenderFns } from "./NewSupplierBtn.vue?vue&type=template&id=5ad37c41&scoped=true&"
import script from "./NewSupplierBtn.vue?vue&type=script&lang=js&"
export * from "./NewSupplierBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad37c41",
  null
  
)

export default component.exports